import Button from './features/ui/Button';
import FriendsList from './features/friends/FriendList';
import FormAddFriend from './features/form/FormAddFriend';
import FormSplitBill from './features/splitBill/FormSplitBill';
import { FriendsProvider, useFriends } from './contexts/FriendsContext';

function AppContent() {
  const { showAddFriend, selectedFriend, dispatch } = useFriends();
  function handleClick() {
    dispatch({ type: 'showAddFriend' });
  }

  return (
    <div className="app">
      <div className="sidebar">
        <FriendsList />

        {showAddFriend && <FormAddFriend />}

        <Button onClick={handleClick}>
          {showAddFriend ? 'Close' : 'Add Friend'}
        </Button>
      </div>

      {selectedFriend && <FormSplitBill />}
    </div>
  );
}

export default function App() {
  return (
    <FriendsProvider>
      <AppContent />
    </FriendsProvider>
  );
}
